import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import DashboardLayout from '@/layouts/DashboardLayout';
import LoginPage from '@/pages/LoginPage';
import DashboardPage from '@/pages/DashboardPage';
import LeadsPage from '@/pages/LeadsPage';
import ContactsPage from '@/pages/ContactsPage';
import CompaniesPage from '@/pages/CompaniesPage';
import CompanyDetailPage from '@/pages/CompanyDetailPage';
import LeadDetailPage from '@/pages/LeadDetailPage';
import OpportunitiesPage from '@/pages/OpportunitiesPage';
import OpportunityDetailPage from '@/pages/OpportunityDetailPage';
import PipelinePage from '@/pages/PipelinePage';
import ActivitiesPage from '@/pages/ActivitiesPage';
import ReportsPage from '@/pages/ReportsPage';
import SettingsPage from '@/pages/SettingsPage';
import InvitePage from '@/pages/InvitePage';
import DashboardDrilldownPage from '@/pages/DashboardDrilldownPage';
import ChangelogPage from '@/pages/ChangelogPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2563EB]" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function PublicRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#2563EB]" />
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<PublicRoute><LoginPage /></PublicRoute>} />
          <Route path="/invite/:token" element={<InvitePage />} />
          <Route path="/" element={<ProtectedRoute><DashboardLayout /></ProtectedRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="leads" element={<LeadsPage />} />
            <Route path="leads/:id" element={<LeadDetailPage />} />
            <Route path="contactos" element={<ContactsPage />} />
            <Route path="empresas" element={<CompaniesPage />} />
            <Route path="empresas/:id" element={<CompanyDetailPage />} />
            <Route path="oportunidades" element={<OpportunitiesPage />} />
            <Route path="oportunidades/:id" element={<OpportunityDetailPage />} />
            <Route path="pipeline" element={<PipelinePage />} />
            <Route path="actividades" element={<ActivitiesPage />} />
            <Route path="reportes" element={<ReportsPage />} />
            <Route path="changelog" element={<ChangelogPage />} />
            <Route path="configuracion" element={<SettingsPage />} />
            <Route path="dashboard/:metric" element={<DashboardDrilldownPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
